import {Fragment} from "react";
import {Badge} from "reactstrap";
import {CgClose} from "react-icons/cg";
import DatePicker from "react-datepicker";
import {useSearchQueryGenerator} from "./useSearchQueryGenerator";
import "react-datepicker/dist/react-datepicker.css";
import "./searchQueryGenerator.scss";

const SearchQueryGenerator = (props) => {
  const {options, placeholder, onChange} = props;
  const {
    clearAll,
    dropdownStage,
    filteredOptions,
    handleCategorySelect,
    handleDateConfirm,
    handleDateSelect,
    handleInputChange,
    handleInputFocus,
    handleKeyDown,
    handleOperatorSelect,
    handleValueSelect,
    inputRef,
    inputValue,
    isDateType,
    removeToken,
    selectedCategory,
    selectedDate,
    showDropdown,
    tokens,
    wrapperRef,
  } = useSearchQueryGenerator(options, onChange);

  return (
    <div className="structured-search-wrapper" ref={wrapperRef}>
      <div
        className="form-control d-flex align-items-center flex-wrap gap-2"
        data-cy="search-query-generator-field"
        onClick={() => inputRef.current?.focus()}
        onKeyDown={() => inputRef.current?.focus()}
        role="button"
        tabIndex={0}
      >
        {tokens.map((token) => (
          <Badge
            className="text-white d-flex align-items-center gap-2"
            color="primary"
            key={token.id}
            style={{fontSize: "0.875rem", padding: "0.35rem 0.5rem"}}
          >
            <span data-cy="token-label">
              {token.category.label} {token.operator} {token.value.label}
            </span>
            <CgClose
              aria-label="Remove"
              cursor="pointer"
              data-cy="remove-button"
              onClick={() => removeToken(token.id)}
            />
          </Badge>
        ))}
        <input
          data-cy="search-query-generator-input"
          onChange={handleInputChange}
          onFocus={handleInputFocus}
          onKeyDown={handleKeyDown}
          placeholder={tokens.length === 0 ? placeholder : ""}
          ref={inputRef}
          type="text"
          value={inputValue}
        />
        {tokens.length > 0 && (
          <CgClose
            aria-label="Remove All"
            cursor="pointer"
            data-cy="remove-all-button"
            onClick={clearAll}
            style={{flexShrink: 0}}
          />
        )}
      </div>

      {showDropdown && (
        <div className="dropdown-menu show" data-cy="search-query-generator-dropdown">
          {dropdownStage === "category" && (
            <Fragment>
              <div className="dropdown-header">Category</div>
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option, index) => (
                  <button
                    className="dropdown-item"
                    data-cy="category-option"
                    key={index}
                    onClick={() => handleCategorySelect(option)}
                    type="button"
                  >
                    {option.category.label}
                  </button>
                ))
              ) : (
                <div className="dropdown-item-text text-muted">
                  No categories available
                </div>
              )}
            </Fragment>
          )}
          {dropdownStage === "operator" && (
            <Fragment>
              <div className="dropdown-header">Operator</div>
              {filteredOptions.map((operator, index) => (
                <button
                  className="dropdown-item"
                  data-cy="operator-option"
                  key={index}
                  onClick={() => handleOperatorSelect(operator)}
                  type="button"
                >
                  {operator}
                </button>
              ))}
            </Fragment>
          )}

          {dropdownStage === "value" && (
            <Fragment>
              <div className="dropdown-header">Value</div>
              {isDateType ? (
                <div className="date-picker-dropdown-container">
                  <DatePicker
                    dateFormat="yyyy-MM-dd"
                    inline
                    maxDate={new Date()}
                    onChange={handleDateSelect}
                    selected={selectedDate}
                  />
                  <div className="date-picker-confirm-row">
                    <button
                      className="btn btn-primary btn-sm"
                      data-cy="date-confirm-button"
                      disabled={!selectedDate}
                      onClick={handleDateConfirm}
                      type="button"
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              ) : (
                <Fragment>
                  {filteredOptions.length > 0 ? (
                    filteredOptions.map((option, index) => (
                      <button
                        className="dropdown-item"
                        data-cy="value-option"
                        key={index}
                        onClick={() => handleValueSelect(option)}
                        type="button"
                      >
                        {option.label}
                      </button>
                    ))
                  ) : (
                    <div className="dropdown-item-text text-muted">
                      {selectedCategory?.isAllowCustomValue
                        ? inputValue
                          ? `Press Enter to add "${inputValue}"`
                          : "Type and press Enter for custom value"
                        : "No options available"}
                    </div>
                  )}
                  {inputValue &&
                    filteredOptions.length > 0 &&
                    selectedCategory?.isAllowCustomValue && (
                      <button
                        className="dropdown-item custom-value-option"
                        data-cy="custom-value-option"
                        type="button"
                        onClick={() =>
                          handleValueSelect({label: inputValue, value: inputValue})
                        }
                      >
                        <em>Add: &quot;{inputValue}&quot;</em>
                      </button>
                    )}
                </Fragment>
              )}
            </Fragment>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchQueryGenerator;
